export default "__VITE_ASSET__CL1ZSw2e__"